import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, ZapIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-primary-dark overflow-hidden lg:pt-24 lg:pb-32 pt-[0px] pb-[0px]" data-id="element-38">
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-primary-dark" data-id="element-39" />

      {/* Background decoration */}

      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent/50 to-transparent" data-id="element-40" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-41">
        <div className="text-center max-w-4xl mx-auto" data-id="element-42">
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.35
        }} className="inline-flex items-center gap-2 bg-accent/10 border border-accent/30 rounded-full px-4 py-1.5 mb-8" data-id="element-43">
            <span className="text-accent text-sm font-bold tracking-wider" data-id="element-44">
              ⭐ EL SISTEMA #1 PARA DOCENTES DE ADMINISTRACIÓN ⭐
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.35,
          delay: 0.06
        }} className="md:text-5xl lg:text-6xl font-extrabold text-white tracking-tighter mb-2 text-[32px]" data-id="element-45">
            ADMINISTRACIÓN 360
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.35,
          delay: 0.1
        }} className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-accent drop-shadow-lg mb-10" data-id="element-46">
            Herramientas Completas
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.14
        }} className="relative max-w-3xl mx-auto mb-8" data-id="element-47">
            <div className="absolute inset-0 bg-accent/20 blur-3xl rounded-full" data-id="element-48" />
            <img src="https://cdn.magicpatterns.com/uploads/fxQBpbWpi63TWLCqbFDbGU/Diseno_sin_titulo-63.png" alt="Administración 360 Product Bundle" loading="eager" decoding="async" fetchPriority="high" className="relative z-10 w-full h-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-500" data-id="element-49" />
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.35,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-50">
            Sistema completo de proyectos, experiencias y evaluaciones listas
            para usar. Todo tu año resuelto en un clic.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.35,
          delay: 0.25
        }} className="flex flex-col items-center" data-id="element-51">
            <a href="#comprar" className="group relative inline-flex items-center justify-center px-8 py-5 text-xl md:text-2xl font-bold text-white bg-cta rounded-full overflow-hidden shadow-[0_0_30px_rgba(220,38,38,0.5)] hover:shadow-[0_0_40px_rgba(220,38,38,0.7)] transition-all transform hover:scale-105 w-full md:w-auto" data-id="element-52">
              <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-full group-hover:h-56 opacity-10" data-id="element-53"></span>
              <span className="relative flex items-center gap-3" data-id="element-54">
                ¡QUIERO ACCEDER AHORA!
                <ZapIcon className="w-6 h-6 animate-pulse" data-id="element-55" />
              </span>
            </a>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-6 text-sm text-gray-400" data-id="element-56">
              <div className="flex items-center gap-2" data-id="element-57">
                <ZapIcon className="w-4 h-4 text-accent" data-id="element-58" />
                <span data-id="element-59">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-60">
                <DownloadIcon className="w-4 h-4 text-accent" data-id="element-61" />
                <span data-id="element-62">Descarga digital</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-63">
                <ShieldCheckIcon className="w-4 h-4 text-accent" data-id="element-64" />
                <span data-id="element-65">Garantía de satisfacción</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}